import { __ } from '@wordpress/i18n';
import {
    TextControl,
    CheckboxControl,
} from '@wordpress/components';
import JoditEditor from 'jodit-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ColorControl from '../../../controls/ColorControl';

const Experience = ({ index,
    itemIndex,
    item,
    handleChangeItemField,
    editor,
handleYearMonChange,
attributes,
setAttributes }) => {

    const {
		experienceDescriptionColor,
		experienceCompanyNameColor,
		experienceDesignationColor,
		experienceDurationColor,
		experienceRoundShapeColor,
		experienceLineColor,
        style
	} = attributes || {};

    return (
        <>
            <div id="section7">
                <TextControl
                    label={__( 'Company Name', 'cv-builder' )}
                    value={ item.name || '' }
                    onChange={( value ) => handleChangeItemField( value, index, itemIndex, 'name' ) }
                />

                <TextControl
                    label={__(
                        'Designation',
                        'cv-builder'
                    )}
                    value={
                        item.designation ||
                        ''
                    }
                    onChange={(
                        value
                    ) =>
                        handleChangeItemField(
                            value,
                            index,
                            itemIndex,
                            'designation'
                        )
                    }
                />

                <div className="year-picker-wrap">
                    <label>{__("From Year", "cv-builder")}</label>
                    <DatePicker
                        showIcon
                        selected={item.fromExpDate ? new Date(item.fromExpDate) : null}
                        onChange={(date) => handleYearMonChange(date, index, itemIndex, "fromExpDate")}
                        dateFormat="yyyy/MM"
                        showMonthYearPicker
                        isClearable
                        placeholderText={__("Select year and month", "cv-builder")}
                    />
                </div>
                <div className="year-picker-wrap">
                    <label>{__("To Year", "cv-builder")}</label>
                    <DatePicker
                        showIcon
                        selected={item.toExpDate ? new Date(item.toExpDate) : null}
                        onChange={(date) => handleYearMonChange(date, index, itemIndex, "toExpDate")}
                        dateFormat="yyyy/MM"
                        showMonthYearPicker
                        isClearable
                        placeholderText={__("Select year and month", "cv-builder")}
                    />
                </div>

                <CheckboxControl
                    label={__(
                        'Present',
                        'cv-builder'
                    )}
                    checked={
                        item.current ||
                        false
                    } // Changed to 'current'
                    onChange={
                        (
                            value
                        ) =>
                            handleChangeItemField(
                                value,
                                index,
                                itemIndex,
                                'current'
                            ) // Changed to 'current'
                    }
                />
            </div>

            <JoditEditor
                ref={ editor }
                value={ item.experienceDescription || '' }
                tabIndex={1}
                onChange={( value ) => handleChangeItemField( value, index, itemIndex, 'experienceDescription' )}
            />
            {style !== 'style26' && style !== 'style27' && style !== 'style28' && (
                <>
            <ColorControl
                label={__(
                'Company Name Color',
                'cv-builder'
                )}
                color={experienceCompanyNameColor}
                colorName="experienceCompanyNameColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            <ColorControl
                label={__(
                'Designation Color',
                'cv-builder'
                )}
                color={experienceDesignationColor}
                colorName="experienceDesignationColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            <ColorControl
                label={__(
                'Duration Color',
                'cv-builder'
                )}
                color={experienceDurationColor}
                colorName="experienceDurationColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            <ColorControl
                label={__(
                'Description Color',
                'cv-builder'
                )}
                color={experienceDescriptionColor}
                colorName="experienceDescriptionColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            <ColorControl
                label={__(
                'Round Shape Color',
                'cv-builder'
                )}
                color={experienceRoundShapeColor}
                colorName="experienceRoundShapeColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            <ColorControl
                label={__(
                'Line Color',
                'cv-builder'
                )}
                color={experienceLineColor}
                colorName="experienceLineColor"
                onChange={(colorObj) => setAttributes(colorObj)}
            />
            </>
            )}
        </>
    )
}

export default Experience